<script>
   export default {
    components: { },
    props: {
      item: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        imgUsuario: "/img/chat/perfilIndividual.png",
        imgGrupo: "/img/chat/perfilGrupo.png",
      }
    },
    computed: {
      imagem() {
        return this.item.grupo > 1 ? this.imgGrupo : this.imgUsuario
      }
    },
    methods: {
      selecionarMensagem() {
        this.$emit('selecionarChanel', { id: this.item.id, titulo: this.item.titulo })
      }
    }
  }
</script>

<template>
  <div class="containerItem" :class="{'selecionado': item.selecionado}" @click="selecionarMensagem">
    <img :src="imagem" class="imagemUsuarioConversa" />
    <div>
      <div class="lblUsuarioConversaNome">{{item.titulo}}</div>
      <div class="lblUsuarioConversaUltimaConversa">{{item.ultimaMensagem}}</div>
    </div>
    <div>
      <div class="lblUsuarioConversaTempo">{{item.dataHoraStr}}</div>
      <div class="lblUsuarioConversaQntMensagem" v-if="item.mensagensNaoLidas > 0"><span class="lblUsuarioConversaQntMensagemTexto">{{item.mensagensNaoLidas}}</span></div>
    </div>
  </div>
</template>

<style>
  .containerItem {
    display: grid;
    align-items: center;
    justify-content: left;
    height: 78px;
    width: 100%;
    background-color: white;
    grid-template-columns: 64px 165px 75px;
    cursor: pointer;
    border-bottom: 0.05rem solid #13141f17;
  }

  .imagemUsuarioConversa {
    height: 48px;
    width: 48px;
    margin-left: 8px;
  }

  .lblUsuarioConversaNome {
    font-size: 11px;
    font-weight: bold;
    font-family: sans-serif;
    color: black;
    color: black;
    margin-bottom: 7px;
  }

  .lblUsuarioConversaTempo {
    font-size: 10px;
    font-weight: bold;
    font-family: sans-serif;
    height: 16px;
    width: 100%;
    color: gray;
    margin-bottom: 10px;
  }

  .lblUsuarioConversaUltimaConversa {
    font-size: 11px;
    font-family: sans-serif;
    height: 18px;
    width: 100%;
    color: gray;
  }

  .lblUsuarioConversaQntMensagem {
    height: 22px;
    width: 22px;
    background-color: #4caf50;
    color: white;
    display: grid;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    margin-left: 38px;
  }

  .lblUsuarioConversaQntMensagemTexto {
    font-weight: bold;
    font-size: 11px;
  }

  .selecionado {
    background-color: #F0F2F5;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/chat/componentes/UsuarioConversas.vue